import { transformErrorResponse } from "../../transformErrorResponse"
import { Peru9112ClaroENTITY, FilesDocDTO } from "sigo-entities"
import { AtcApiBuilder } from "."

export const PERU_9112_ClaroOrder = (build: AtcApiBuilder) => {
    return {
        getByIdClaroOrders: build.query<Peru9112ClaroENTITY[], string>({
            query: (userId) => `procesos/PERU_9112_ClaroOrder/${userId}`,
            providesTags: (result, error, userId) =>
                result
                    ? [
                        // tag individual por cada orden
                        ...result.map((order) => ({
                            type: 'ClaroOrders' as const,
                            id: order._id,
                        })),
                        // y un tag general de la lista de ese usuario
                        { type: 'ClaroOrders' as const, id: `USER-${userId}` },
                    ]
                    : [{ type: 'ClaroOrders' as const, id: `USER-${userId}` }],
            transformErrorResponse
        }),
        getTransitClaroOrders: build.query<{ transito: number }, { id_recurso: string, codigo: number }>({
            query: ({ id_recurso, codigo }) => `procesos/PERU_9112_ClaroOrder/calculate-transit/${id_recurso}/${codigo}`,
            transformErrorResponse
        }),
        addInventoryClaroOrders: build.mutation<Peru9112ClaroENTITY, { id: string, body: { ID_StockPersonal: number, cantidad: number, Serie?: { Serie: string, ID_StockPersonalEquipos: number } } }>({
            query: ({ body, id }) => ({
                url: `procesos/PERU_9112_ClaroOrder/add-inventory/${id}`,
                method: "PUT",
                body,
            }),
            invalidatesTags: (result, error, { id }) => [
                { type: 'ClaroOrders' as const, id },
            ],
            transformErrorResponse
        }),
        deleteInventoryClaroOrders: build.mutation<Peru9112ClaroENTITY, { id: string, codigo: number, serie: string }>({
            query: ({ id, codigo, serie }) => ({
                url: `procesos/PERU_9112_ClaroOrder/delete-inventory/${id}/${codigo}?serie=${serie}`,
                method: "PUT",
            }),
            invalidatesTags: (result, error, { id }) => [
                { type: 'ClaroOrders' as const, id },
            ],
            transformErrorResponse
        }),
        finalizeClaroOrders: build.mutation<Peru9112ClaroENTITY, { id: string }>({
            query: ({ id }) => ({
                url: `procesos/PERU_9112_ClaroOrder/finalize/${id}`,
                method: "PUT"
            }),
            invalidatesTags: (result, error, { id }) => [
                // invalida la orden puntual
                { type: 'ClaroOrders' as const, id },
                // y también la lista del usuario (para que se refresque)
                // { type: 'WINOrders' as const, id: `USER-${userId}` },
            ],
            transformErrorResponse
        }),
        uploadPhotosClaroOrders: build.mutation<Peru9112ClaroENTITY, { id: string, boletin: FilesDocDTO }>({
            query: ({ boletin, id }) => ({
                url: `procesos/PERU_9112_ClaroOrder/upload-files/${id}`,
                method: "PUT",
                body: { boletin },
            }),
            invalidatesTags: (result, error, { id }) => [
                { type: 'ClaroOrders' as const, id },
            ],
            transformErrorResponse
        }),
    }
}